import { MappingClientT, ViewClientT } from 'bovaljaren-models';
import { useObserver } from 'mobx-react-lite';
import React, { ReactElement, useContext } from 'react';
import { AppContext } from '../../../../../state/app.state';
import Polygon from '../../Polygon/Polygon';

type SvgMappingViewPolygonsProps={
    lastHovered: string;
    setLastHovered: (value: string) => void;
    onObjectMouseEnter?: (object: MappingClientT) => void;
    onObjectMouseLeave?: (object: MappingClientT) => void;
    disableObjectTouchInteraction: boolean
};

const SvgMappingViewPolygons: React.FC<SvgMappingViewPolygonsProps> = ({ setLastHovered, onObjectMouseEnter, onObjectMouseLeave, disableObjectTouchInteraction }): ReactElement => {
    const { state, presentationState } = useContext(AppContext);

    const getClassName = (v: MappingClientT, view: ViewClientT | undefined, inactive: boolean): string => {
        let className = 'bv-link';

        if (inactive) {
            className = 'bv-link-inactive';
        }

        if (presentationState?.activePreview) {
            className = className.concat(' bv-mapping-fade');
        }

        if ((view?.mappings.objects.find(({ mappingEntityId }) => state?.isCurrentPreviewObject(mappingEntityId)) || state?.isCurrentPreviewObject(v.mappingEntityId)) && !inactive) {
            className = className.concat(' bv-pop-animation');
        }

        return className;
    };

    const onMouseEnter = (v: MappingClientT, inactive: boolean) => {
        if (disableObjectTouchInteraction) return;

        if (inactive) return;

        v.mappingEntityId && state?.setPreviewObjectId(v.mappingEntityId);

        setLastHovered(`bv-polygon-view-${v.id}`);

        if (onObjectMouseEnter) {
            onObjectMouseEnter(v);
        }
    };

    const onMouseLeave = (v: MappingClientT, inactive: boolean) => {
        if (disableObjectTouchInteraction) return;

        if (inactive) return;

        state?.setPreviewObjectId(undefined);
        setLastHovered('');

        if (onObjectMouseLeave) {
            onObjectMouseLeave(v);
        }
    };


    return useObserver(() => (
        <>
            {state?.currentView?.mappings.views?.map((v: MappingClientT, index: number) => {
                const inactive = !state.project?.views.find(vP => vP.id === v.mappingEntityId);
                const view = state.project?.views.find(vV => vV.id === v.mappingEntityId);

                return <Polygon
                    key={v.id}
                    polygon={v.polycords}
                    disablePolygonTouchInteraction={disableObjectTouchInteraction}
                    inactive={inactive}
                    className={getClassName(v, view, inactive)}
                    onMouseEnter={() => onMouseEnter(v, inactive)}
                    onMouseLeave={() => onMouseLeave(v, inactive)}
                    onClick={(): void => {
                        !inactive && state.changeView && state.changeView(v.mappingEntityId);
                    }}
                />;
            })}
        </>));
};


export default SvgMappingViewPolygons;